import { createFileRoute } from "@tanstack/react-router";
import { PlateStatus } from "../../app/views/pcr/plateStatus";

export const Route = createFileRoute("/pcr/status")({
  component: PlateStatus,
});
